// extracted by mini-css-extract-plugin
export default {"swalcustomzindex":"user-form_swalcustomzindex__SJjA3"};